import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import _ from 'lodash';
import { validateEmail } from '../../helpers/commonFormFieldValidators';
var messages = defineMessages({
  required: {
    id: "General.Required",
    defaultMessage: [{
      "type": 0,
      "value": "Required"
    }]
  },
  wrongFormat: {
    id: "General.WrongFormat",
    defaultMessage: [{
      "type": 0,
      "value": "Wrong format"
    }]
  },
  sameEmail: {
    id: "General.sameEmail",
    defaultMessage: [{
      "type": 0,
      "value": "this email is duplicated"
    }]
  }
});
export default (function (values, props) {
  var errors = {
    signerEmails: []
  };
  if (!props.isMultipleSigners) {
    if (!values.signerEmail || !values.signerEmail.trim()) {
      errors.signerEmail = /*#__PURE__*/React.createElement(FormattedMessage, messages.required);
    }
    if (values.signerEmail && !validateEmail(values.signerEmail)) {
      errors.signerEmail = /*#__PURE__*/React.createElement(FormattedMessage, messages.wrongFormat);
    }
  } else {
    var emails = [];
    _.each(_.get(values, 'signerEmails', []), function (signerEmail, index) {
      if (!signerEmail || !signerEmail.trim()) {
        errors.signerEmails[index] = /*#__PURE__*/React.createElement(FormattedMessage, messages.required);
      }
      if (signerEmail && !validateEmail(signerEmail)) {
        errors.signerEmails[index] = /*#__PURE__*/React.createElement(FormattedMessage, messages.wrongFormat);
      }
      if (_.includes(emails, _.get(values, "signerEmails[".concat(index, "]")))) {
        errors.signerEmails[index] = /*#__PURE__*/React.createElement(FormattedMessage, messages.sameEmail);
      }
      emails.push(_.get(values, "signerEmails[".concat(index, "]")));
    });
  }
  return errors;
});